import React, { useState, useRef, useEffect } from "react"
import PropTypes from 'prop-types'
import { connect, useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import { showRightSidebarAction, toggleLeftmenu, setEmpresaSeleccionada, fetchEmpresas } from "../../store/actions"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import QaBanner from "../CommonForBoth/QaBanner"
import ApiEnvSwitcher from "../CommonForBoth/ApiEnvSwitcher"
import logo from "../../assets/images/lsda-logo.png"
import logoLight from "../../assets/images/lsda-logo.png"
import logoDark from "../../assets/images/lsda-logo.png"
import { withTranslation } from "react-i18next"

const Header = props => {
  const { user, empresaSeleccionada, empresas } = props;
  const [isOpen, setIsOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const dropdownRef = useRef(null)
  const inputRef = useRef(null)

  // Cerrar dropdown al hacer click fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
        setSearchTerm("")
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  // Cargar empresas si están vacías (ej: después de refresh de página o token)
  useEffect(() => {
    if (user && (!empresas || empresas.length === 0)) {
      dispatch(fetchEmpresas())
    }
  }, [user, empresas, dispatch])

  // Auto-focus en el input al abrir
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isOpen])

  const handleEmpresaChange = (empresa) => {
    dispatch(setEmpresaSeleccionada(empresa, navigate))
    setIsOpen(false)
    setSearchTerm("")
  }

  const filteredEmpresas = (empresas || []).filter(empresa =>
    empresa.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    empresa.nit?.includes(searchTerm)
  )

  return (
    <React.Fragment>
      <QaBanner />
      <div className="navbar-header">
        <Container fluid>
          <div className="float-start">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="80" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="80" />
                </span>
              </Link>
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 d-lg-none header-item waves-effect waves-light"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu)
              }}
              data-target="#topnav-menu-content"
            >
              <i className="mdi mdi-menu"></i>
            </button>
          </div>

          <div className="float-end d-flex align-items-center">

            {/* ── Selector de entorno de datos (Prod/QA) ── */}
            <ApiEnvSwitcher />

            {/* ── Acceso al portal de Nómina (abre en pestaña nueva) ── */}
            <a
              href="https://nom.ls-da.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn header-item waves-effect me-2"
              title="Abrir el portal de Nómina en una pestaña nueva"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                border: "1px solid #c7d2fe",
                borderRadius: 8,
                padding: "6px 14px",
                backgroundColor: "#eef2ff",
                color: "#4f46e5",
                fontWeight: 600,
                fontSize: "0.85rem",
                textDecoration: "none",
              }}
            >
              <i className="mdi mdi-account-cash font-size-18" />
              <span className="d-none d-md-inline">Nómina</span>
              <i className="mdi mdi-open-in-new font-size-14" />
            </a>

            {/* ── Selector de empresa con búsqueda ── */}
            <div ref={dropdownRef} style={{ position: "relative" }} className="me-2">
              {/* Botón principal */}
              <button
                className="btn header-item waves-effect"
                onClick={() => setIsOpen(!isOpen)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  padding: "6px 14px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                {empresaSeleccionada?.logoUrl ? (
                  <img
                    src={empresaSeleccionada.logoUrl}
                    alt=""
                    style={{ width: 24, height: 24, objectFit: "contain", borderRadius: 4 }}
                    onError={e => { e.target.style.display = "none" }}
                  />
                ) : (
                  <i className="mdi mdi-office-building font-size-18 text-primary" />
                )}
                <span
                  style={{
                    maxWidth: 220,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                  }}
                >
                  {empresaSeleccionada?.nombre || "Seleccionar empresa"}
                </span>
                <i className={`mdi mdi-chevron-${isOpen ? "up" : "down"} font-size-16`} />
              </button>

              {/* Dropdown con búsqueda */}
              {isOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    marginTop: 4,
                    width: 340,
                    backgroundColor: "#fff",
                    borderRadius: 10,
                    boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
                    border: "1px solid #e2e8f0",
                    zIndex: 1050,
                    overflow: "hidden",
                  }}
                >
                  {/* Input de búsqueda */}
                  <div style={{ padding: "12px 14px 8px" }}>
                    <div style={{ position: "relative" }}>
                      <i
                        className="mdi mdi-magnify"
                        style={{
                          position: "absolute",
                          left: 10,
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#94a3b8",
                          fontSize: 18,
                        }}
                      />
                      <input
                        ref={inputRef}
                        type="text"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        placeholder="Buscar empresa..."
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 36px",
                          border: "1px solid #e2e8f0",
                          borderRadius: 8,
                          fontSize: "0.85rem",
                          outline: "none",
                          backgroundColor: "#f8fafc",
                        }}
                        onFocus={e => { e.target.style.borderColor = "#556ee6" }}
                        onBlur={e => { e.target.style.borderColor = "#e2e8f0" }}
                      />
                    </div>
                  </div>

                  {/* Lista de empresas */}
                  <div style={{ maxHeight: 320, overflowY: "auto", padding: "0 6px 8px" }}>
                    {filteredEmpresas.length > 0 ? (
                      filteredEmpresas.map(empresa => {
                        const isActive = empresaSeleccionada?.id === empresa.id
                        return (
                          <div
                            key={empresa.id}
                            onClick={() => handleEmpresaChange(empresa)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                              padding: "9px 10px",
                              borderRadius: 8,
                              cursor: "pointer",
                              backgroundColor: isActive ? "#eef2ff" : "transparent",
                              transition: "background-color 0.15s",
                            }}
                            onMouseEnter={e => {
                              if (!isActive) e.currentTarget.style.backgroundColor = "#f1f5f9"
                            }}
                            onMouseLeave={e => {
                              if (!isActive) e.currentTarget.style.backgroundColor = "transparent"
                            }}
                          >
                            {empresa.logoUrl ? (
                              <img
                                src={empresa.logoUrl}
                                alt=""
                                style={{ width: 32, height: 32, objectFit: "contain", borderRadius: 6, flexShrink: 0 }}
                                onError={e => { e.target.style.display = "none" }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: 6,
                                  backgroundColor: isActive ? "#556ee6" : "#94a3b8",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: 15,
                                  fontWeight: "bold",
                                  color: "#fff",
                                  flexShrink: 0,
                                }}
                              >
                                {empresa.nombre?.charAt(0)?.toUpperCase()}
                              </div>
                            )}
                            <div style={{ overflow: "hidden", flex: 1 }}>
                              <div
                                style={{
                                  fontWeight: isActive ? 700 : 500,
                                  fontSize: "0.85rem",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  color: isActive ? "#556ee6" : "#1e293b",
                                }}
                              >
                                {empresa.nombre}
                              </div>
                              <small style={{ color: "#94a3b8", fontSize: "0.75rem" }}>
                                NIT: {empresa.nit}{empresa.digVerificacion ? `-${empresa.digVerificacion}` : ""}
                              </small>
                            </div>
                            {isActive && (
                              <i className="mdi mdi-check-circle text-success font-size-16" />
                            )}
                          </div>
                        )
                      })
                    ) : (
                      <div style={{ padding: "16px 10px", textAlign: "center", color: "#94a3b8", fontSize: "0.85rem" }}>
                        <i className="mdi mdi-magnify-close font-size-24 d-block mb-1" />
                        No se encontraron empresas
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <ProfileMenu />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  user: PropTypes.object,
  empresaSeleccionada: PropTypes.object,
  empresas: PropTypes.array,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout
  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    user: state.Login.user,
    empresaSeleccionada: state.Login.empresaSeleccionada,
    empresas: state.Login.empresas,
  }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header))